module.exports = __webpack_public_path__ + "img/coastCleanUp_041022_D.bf8abb3c.jpg";